<template>
  <v-app>
    <component :is="layout" />

    <alert-component />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BlankLayout from './layouts/Blank.vue';
import AppLayout from './layouts/App.vue';
import AlertComponent from './components/global/AlertComponent.vue';

export default {
  name: 'App',

  components: {
    BlankLayout,
    AppLayout,
    AlertComponent,
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'getPermissions', 'getTokensRequest']),
    ...mapGetters('auth', { me: 'getUser', refreshToken: 'getRefreshToken', session: 'getSession' }),

    layout() {
      return `${this.$route.meta.layout || 'app'}-layout`;
    },
  },

  watch: {
    me(val) {
      if (val) {
        window.addEventListener('focus', this.refreshUserSession);
      } else {
        window.removeEventListener('focus', this.refreshUserSession);
      }
    },
  },

  created() {
    this._initApp();
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      fetchMe: 'auth/fetchMe',
      fetchLanguages: 'languages/fetchAll',
      fetchCurrencies: 'currencies/fetchAll',
      refreshSession: 'auth/refreshSession',
    }),

    refreshUserSession() {
        if (new Date(this.session.accessExpirationAt).getTime() > Date.now() + 1800000) {
            return;
        }
        console.log('focus_refresh');
        this.refreshSession({ refreshToken: this.refreshToken });
    },

    async _initApp() {
      this.fetchLanguages();
      this.fetchCurrencies();

      if (this.getTokensRequest) {
        await this.getTokensRequest;
      }

      if (this.isAuthenticated) {
        this.fetchMe();
      } else {
        this.$router.push({ name: 'logout' });
      }
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
  margin-bottom: 1rem;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.v-application {
  .header .v-input,
  .v-navigation-drawer {
    background-color: #fff;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }

  .header fieldset {
    border: none !important;
  }

  .action-button {
    box-shadow: none;
    color: #717171;

    &:not(:last-child) {
      margin-right: 0.5rem;
    }
  }

  .action-button--error {
    color: #ff5256;
  }

  .flex-grow-7 {
    flex-grow: 55 !important;
  }

  .flex-grow-3 {
    flex-grow: 3 !important;
  }
}

.graph-height {
  max-height: 500px;
}

.text-normal {
  text-transform: none;
}

.color-white {
  color: #fff !important;
}

.link--white {
  color: currentColor !important;
  text-decoration: underline !important;
}

.mb-24 {
  margin-bottom: 6rem;
}

.mb-md-32 {
  @media screen and (min-width: 960px) {
    margin-bottom: 8rem;
  }
}

.flex-1 {
  flex: 1 1 0;
}

.flex-2 {
  flex: 2 2 0;
}

.flex-auto {
  flex: auto;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-y-4 {
  column-gap: 0.5rem;
}

.gap-12 {
  gap: 3rem;
}

.w-100 {
  width: 100%;
}

.w-50 {
  width: 50%;
}

.h-100 {
  height: 100%;
}

.rotate-90 {
  transform: rotate(90deg);
}

.text-primary {
  color: #673ab7;
}

.text-red {
  color: red;
}

.text-white {
  color: #ffffff;
}

.text-xs {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}

.text-xl {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}

.font-bold {
  font-weight: 700;
}

.g-u-whitespace-nowrap {
  white-space: nowrap;
}
</style>
